import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmContext } from 'legacy/lut/components/shared/Confirm/ConfirmContext'
import { confirmDialogReducer, initialState } from 'legacy/lut/components/shared/Confirm/reducer'
import React, { useReducer, useRef } from 'react'

type Props = {
  children: React.ReactNode
}

export type ResolveCallback = (value: boolean) => void
export type ConfirmDialogResolver = Partial<Record<ConfirmDialogIdentifier, ResolveCallback>>

export function ConfirmContextProvider(props: Props) {
  const resolveRef = useRef<ConfirmDialogResolver>({})
  const [state, dispatch] = useReducer(confirmDialogReducer, initialState)

  return (
    <ConfirmContext.Provider value={[state, dispatch, resolveRef]}>
      {props.children}
    </ConfirmContext.Provider>
  )
}
